module.exports = __webpack_public_path__ + "media/images/sales/set/heading-mv-set-05f372c97a715d72c615af48ee72c8ce.svg";